import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BoxWrapper } from "./TripDrawer";
import { useGet, usePost } from "../../../hooks/api-call";
import { useEffect } from "react";
import useCustomToast from "../../../hooks/use-toast";
import { baseURL } from "../../../hooks/helper";
import { useAuth } from "../../../auth/AuthProvider";

const EditSubSectionTrip = ({
  editabeTripId,
  setRefreshHistory,
  truckHistory,
  setToBeUpdateUI,
}) => {

      const { token } = useAuth();
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
};
  const { responseData: tripStages } = useGet(`possibleTripStages`);
  const { responseData: existingTripStages } = useGet(
    `trip/${editabeTripId}/tripStages`
  );
  const [selectedTripStage, setSelectedTripStage] = useState(0);
  const [weight, setWeight] = useState("");
  const [ravanaNo, setRavanaNo] = useState("");
  const [challanNo, setChallanNo] = useState("");
  const [finalPayment, setFinalPayment] = useState("");
  const [disabledStatus, setDisabledStatus] = useState(false);
  const [errors, setErrors] = useState({
    rawanna: "",
    challan: "",
    weight: "",
  });

  const { postData } = usePost();
  const { showSuccessToast, showErrorToast } = useCustomToast();

  const handleUpdateTrip = async () => {
    const isValid = validateFields();
    console.log("====errors.challan && errors.rawanna && errors.weight=",isValid);
    
  if (!isValid) {
    console.log("Form is invalid. Please fix the errors.");
    return;
  }
    const resp = {
      ravanaNumber: ravanaNo,
      finalPayment: finalPayment,
      challanNo
    };

    if (weight) {
      resp['weightAtThisStage'] = weight;
    }

    try {
      await postData(
        resp,
        `trip/${editabeTripId}/tripStages/${selectedTripStage?.stageSeqId}`
      );
      showSuccessToast("Success", `Trip status updated successfully`);
      setRefreshHistory((p) => !p);
      setToBeUpdateUI();
    } catch (error) {
      showErrorToast("Error", error?.response?.data);
    }
  };

  useEffect(() => {
    setWeight("");
    setRavanaNo("");
    setChallanNo("")
  }, [selectedTripStage]);

  useEffect(() => {
    if (
      tripStages &&
      tripStages.length > 0 &&
      truckHistory &&
      !!truckHistory.length
    ) {
      const item = truckHistory.sort().pop();
      const resp = tripStages.filter((f) => f.stageSeqId == item + 1);
      if (!!resp.length) {
        if (
          +resp[0]?.stageSeqId === 5 &&
          !!existingTripStages &&
          existingTripStages.length > 0
        ) {
          setTimeout(() => {
            setWeight(existingTripStages[0]?.weightAtThisStage);
            setRavanaNo(existingTripStages[0]?.ravanaNumber);
          }, 200);
        }
        setSelectedTripStage(resp[0]);
        setDisabledStatus(false);
      } else {
        const items = tripStages.filter((f) => f.stageSeqId == item);
        setSelectedTripStage(items[0]);
        setDisabledStatus(true);
      }
    }
  }, [tripStages, truckHistory]);

  const handleRawannaChange = (e) => {
    setRavanaNo(e.target.value);
    if (errors.rawanna) {
      setErrors(prev => ({ ...prev, rawanna: "" }));
    }
  };
  
  const handleChallanChange = (e) => {
    setChallanNo(e.target.value);
    if (errors.challan) {
      setErrors(prev => ({ ...prev, challan: "" }));
    }
  };
  
  const handleWeightChange = (e) => {
    setWeight(e.target.value);
    if (errors.weight) {
      setErrors(prev => ({ ...prev, weight: "" }));
    }
  };

  const handleRawannaBlur = async () => {
    if (!ravanaNo) return;
  
    try {
      const res = await fetch(`${baseURL}/trips/rawannaNoExists/${ravanaNo}`, { headers });
      const data = await res.json();
  
      setErrors(prev => ({
        ...prev,
        rawanna: data ? "Rawanna number already exists" : ""
      }));
    } catch (e) {
      console.error("Rawanna check failed:", e);
    }
  };
  
  const handleChallanBlur = async () => {
    if (!challanNo) return;
  
    try {
      const res = await fetch(`${baseURL}/trips/challanNoExists/${challanNo}`, { headers });
      const data = await res.json();
  
      setErrors(prev => ({
        ...prev,
        challan: data ? "Challan number already exists" : ""
      }));
    } catch (e) {
      console.error("Challan check failed:", e);
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if((selectedTripStage?.stageSeqId == 5 || selectedTripStage?.stageSeqId == 8) ) {
      if (!weight) {
        newErrors.weight = "Weight is required";
      } else if (+weight === 0) {
        newErrors.weight = "Weight cannot be 0";
      }
    }
  
    if (selectedTripStage?.stageSeqId === 5 && !ravanaNo) {
      newErrors.rawanna = "Rawanna number is required";
    }
  
    if (selectedTripStage?.stageSeqId === 5 && !challanNo) {
      newErrors.challan = "Challan number is required";
    }

    console.log("===newErrors=",newErrors);
    
  
    setErrors(prev => ({ ...prev, ...newErrors }));
  
    const hasErrors = Object.keys({ ...errors, ...newErrors }).some(
      (key) => !!errors[key] || !!newErrors[key]
    );
  
    return !hasErrors;
  };
  

return (
  <Box>
    <BoxWrapper>
      <Flex justifyContent={"space-between"}>
        <Box>
          <Text color={"rgba(5, 30, 92, 1)"} fontSize={"20px"}>
            Trip Stage
          </Text>
          <Text color={"rgba(166, 166, 166, 1)"}>
            Select the value to update Truck's journey
          </Text>
        </Box>
        <Text color={"blue"}>Generate Bilty</Text>
      </Flex>
      <Flex mt={3}>
        <Select
          name="stageSeqId"
          onChange={(e) => setSelectedTripStage(JSON.parse(e.target.value))}
          value={selectedTripStage?.stageSeqId}
          disabled={disabledStatus}
        >
          {selectedTripStage?.stageName && (
            <option>{selectedTripStage?.stageName}</option>
          )}
          {/* {tripStages &&
              tripStages.length > 0 &&
              tripStages.map((tripStage, index) => {
                return (
                  <option
                    key={tripStage?.stageSeqId}
                    value={JSON.stringify(tripStage)}
                    disabled={truckHistory.includes(tripStage?.stageSeqId)}
                  >
                    {tripStage?.stageName}
                  </option>
                );
              })} */}
        </Select>
        <Button
          colorScheme="blue"
          w={"200px"}
          disabled={disabledStatus}
          cursor={disabledStatus ? "default" : "pointer"}
          ml={2}
          onClick={() => !disabledStatus && handleUpdateTrip()}
        >
          Update
        </Button>
      </Flex>
      {(selectedTripStage?.stageSeqId == 5 ||
        selectedTripStage?.stageSeqId == 8) && (
          <Flex gap={5} mt={4}>
            <FormControl isRequired={selectedTripStage?.stageSeqId == 8}>
              <FormLabel color={"#191b1c"}>Weight</FormLabel>
              <Input
                name="weight"
                type="text"
                onChange={handleWeightChange}
                value={weight}
              />
                  {errors.weight && <Text color="red.500">{errors.weight}</Text>}
            </FormControl>
            {selectedTripStage?.stageSeqId != 8 && (
              <FormControl>
                <FormLabel color={"#191b1c"}>Rawanna No</FormLabel>
                <Input
                  name="ravanaNo"
                  type="text"
                  value={ravanaNo}
                  onChange={handleRawannaChange}
                  onBlur={handleRawannaBlur}
                  />
                  {errors.rawanna && <Text color="red.500">{errors.rawanna}</Text>}
              </FormControl>
            )}
            {selectedTripStage?.stageSeqId != 8 && (
              <FormControl>
                <FormLabel color={"#191b1c"}>Challan</FormLabel>
                <Input
                  name="challan"
                  type="text"
                  value={challanNo}
                  onChange={handleChallanChange}
                  onBlur={handleChallanBlur}
                />
                  {errors.challan && <Text color="red.500">{errors.challan}</Text>}

              </FormControl>
            )}
          </Flex>
        )}
      {selectedTripStage?.stageSeqId == 9 && (
        <Flex mt={3}>
          <FormControl isRequired={selectedTripStage?.stageSeqId == 8}>
            <FormLabel color={"#191b1c"}>Amount (INR)</FormLabel>
            <Input
              disabled={disabledStatus}
              name="finalPayment"
              type="text"
              value={finalPayment}
              onChange={(e) => setFinalPayment(e.target.value)}
            />
          </FormControl>
        </Flex>
      )}
    </BoxWrapper>
  </Box>
);
};

export default EditSubSectionTrip;
